import React, {Component} from 'react';
import {Profile, Common} from '../components';

export default class ProfileTemplate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isEdited: false,
            birthday: this.props.user.birthday,
            gender: this.props.user.gender,
            nick_name: this.props.user.nick_name,
            prefecture: this.props.user.prefecture
        };

        this.updateLocalState = (newLocalState) => {
            this.setState(newLocalState)
        }

        this.toggleEditState = () => {
            this.setState({isEdited: !this.state.isEdited})
        }
    }

    render() {
        return (
            <main>
                <Common.Spacer size={"medium"} quantity={2} />

                <section className="c-section__wrapin-narrow">
                    <div className="p-grid__list">
                        <div className="p-grid__list-item">
                            {(this.state.isEdited) ? (
                                <button className="c-btn-primary c-btn-small" onClick={() => {
                                    this.toggleEditState();
                                    this.props.updateUserProfile({
                                        birthday: this.state.birthday,
                                        gender: this.state.gender,
                                        nick_name: this.state.nick_name,
                                        prefecture: this.state.prefecture
                                    })
                                }}>決定</button>
                            ) : (
                                <button className="c-btn-primary c-btn-small" onClick={() => this.toggleEditState()}>編集</button>
                            )}
                        </div>

                        <div className="p-grid__list-item">
                            <h3>ニックネーム</h3>
                            {(this.state.isEdited) ? (
                                <Profile.TextInputField type={"nick_name"} value={this.state.nick_name} onChange={this.updateLocalState}/>
                            ) : (
                                <Profile.TextField type={"nick_name"} value={this.props.user.nick_name} />
                            )}
                        </div>
                        <div className="p-grid__list-item">
                            <h3>生年月日</h3>
                            {(this.state.isEdited) ? (
                                <Profile.DatePickers type={"birthday"} value={this.state.birthday} onChange={this.updateLocalState}/>
                            ) : (
                                <Profile.TextField type={"birthday"} value={this.props.user.birthday} />
                            )}
                        </div>
                        <div className="p-grid__list-item">
                            <h3>性別</h3>
                            {(this.state.isEdited) ? (
                                <Profile.SelectField type={"gender"} value={this.state.gender} onChange={this.updateLocalState}/>
                            ) : (
                                <Profile.TextField type={"gender"} value={this.props.user.gender} />
                            )}
                        </div>
                        <div className="p-grid__list-item">
                            <h3>所在地</h3>
                            {(this.state.isEdited) ? (
                                <Profile.SelectField type={"prefecture"} value={this.state.prefecture} onChange={this.updateLocalState}/>
                            ) : (
                                <Profile.TextField type={"prefecture"} value={this.props.user.prefecture} />
                            )}
                        </div>
                    </div>
                </section>

                <Common.Spacer size={"medium"} quantity={1} />
            </main>
        )
    }
}